// @ts-nocheck
/* eslint-disable */
import { _ } from "~/i18n";
import { node, icon } from "~/util/dom";

/**
 * Button do galerie pro upload fotek
 * data.source
 * data.id
 * data.likeCount
 * data.like
 */
export function likeButton(data) {
	const button = node("button", { className: `like-button${data.like ? ` liked` : ``}`, type: "button", title: data.likeCount ? Mapy.Util.formatLocaleNumber(data.likeCount) : 0 });
	button.innerHTML = `<span>${_("photo.like")}</span><i>${data.likeCount ? Mapy.Util.formatLocaleNumber(data.likeCount) : 0}</i>`;

	button.firstChild.before(icon("heart"));

	button.setAttribute("data-log-ignore", "1");

	return button;
};
